import { EVENT_MAP, eventNumbers, eventMinute, targetLabel, teamName } from "@/lib/events";

export const KEY_TYPES = ["pp", "pp_por_assinalar", "vermelho", "cv_por_exibir", "ca_por_exibir"];

export const keyMoments = (m) => {
  const nums = eventNumbers(m);
  return m.events.filter((e) => KEY_TYPES.includes(e.type)).sort((a, b) => nums[a.id] - nums[b.id]);
};

export const keyMomentRows = (m) =>
  keyMoments(m).map((e) => [eventMinute(e, m.half2_reset), EVENT_MAP[e.type].label, teamName(m, e.team), e.target ? targetLabel(e) : "Sem identificação", e.zone || "—", e.note || "—"]);

export const KeyMoments = ({ match }) => {
  const list = keyMoments(match);
  return (
    <section data-testid="key-moments" className="border border-white/15 bg-[#131313] p-4 sm:p-6">
      <h2 className="font-display text-2xl font-bold uppercase mb-4">Lances relevantes <span className="text-zinc-500 tabular-nums">· {list.length}</span></h2>
      {!list.length && <p data-testid="key-moments-empty" className="text-sm text-zinc-500">Sem lances relevantes neste jogo.</p>}
      <ol className="divide-y divide-white/10">
        {list.map((e, i) => {
          const t = EVENT_MAP[e.type];
          return (
            <li key={e.id} data-testid={`key-moment-${i + 1}`} className="py-3 flex gap-3 sm:gap-4">
              <span className="w-16 sm:w-20 shrink-0 font-display text-xl sm:text-2xl font-bold tabular-nums">{eventMinute(e, match.half2_reset)}</span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-2 py-0.5 font-display font-bold text-xs sm:text-sm" style={{ background: t.color, color: t.text }}>{t.short}</span>
                  <span className="font-semibold">{t.label}</span>
                  <span className="text-zinc-400 text-sm">{[e.team && teamName(match, e.team), e.target ? targetLabel(e) : "Sem identificação", e.zone && `Zona ${e.zone}`].filter(Boolean).join(" · ")}</span>
                </div>
                {e.note && <p data-testid={`key-moment-${i + 1}-note`} className="text-sm text-zinc-300 italic mt-1 break-words">“{e.note}”</p>}
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
